import React, {useContext} from 'react';
import Header from "../components/Header";
import SimpleHeader from "../components/SimpleHeader";
import Footer from "../components/Footer";
import { LanguageContext } from "../languages/LanguageContext";
import {BiSolidPhoneCall} from "react-icons/bi";
import {MdEmail} from "react-icons/md";
import {Link} from "react-router-dom";
import PageTitle from "../components/PageTitle";

const Contact = () => {
    const { language, translations } = useContext(LanguageContext);
    return (
        <>
            <PageTitle title='Contact' />
            <Header />
            <div className='main-container'>
                <SimpleHeader
                    title={"contact"}
                    route={"contact"}
                    url={"contact"}
                />
                <div className='contact-container max-w flex col gap-2'>
                    <div className='team-introduction flex wrap'>
                        <h2>{translations[language]["contactTitle"]}</h2>
                        <div className='content-container'>
                            <p>{translations[language]["contactInfo1"]}</p>
                            <br />
                            <p>{translations[language]["contactInfo2"]}</p>
                        </div>
                        <div className='image-container'>
                            <img src='/art/team.svg' alt='team' />
                        </div>
                    </div>
                    <div className='contact-grid'>
                        <div className='contact-member flex col'>
                            <h3>{translations[language]["contactAldonaTitle"]}</h3>
                            <span><BiSolidPhoneCall className='icon-phone' /> +43 699 120 358 34</span>
                            <span>
                                <MdEmail className='icon-mail' />
                                <Link to='mailto:aldona.biedermann@gmail.com'> aldona.biedermann@gmail.com </Link>
                            </span>
                        </div>
                        <div className='contact-member'>
                            <h3>{translations[language]["contactRaimondaTitle"]}</h3>
                            <span><BiSolidPhoneCall className='icon-phone' /> +49 176 200 833 35</span>
                            <span>
                                <MdEmail className='icon-mail' />
                                <Link to='mailto:r.vincaite@ieep-berlin.de'> r.vincaite@ieep-berlin.de </Link>
                            </span>
                        </div>
                        {/*<div className='contact-member'>*/}
                        {/*    <h3>{translations[language]["contactJanaTitle"]}</h3>*/}
                        {/*    <span>*/}
                        {/*        <MdEmail className='icon-mail' />*/}
                        {/*        <Link to='mailto:JHoskovcova@oacl.cz'> JHoskovcova@oacl.cz </Link>*/}
                        {/*    </span>*/}
                        {/*</div>*/}
                        {/*<div className='contact-member'>*/}
                        {/*    <h3>{translations[language]["contactTomekTitle"]}</h3>*/}
                        {/*    <span><BiSolidPhoneCall className='icon-phone' /> +48 661 157 308</span>*/}
                        {/*    <span>*/}
                        {/*        <MdEmail className='icon-mail' />*/}
                        {/*        <Link to='mailto:tomek82@autograf.pl'> tomek82@autograf.pl </Link>*/}
                        {/*    </span>*/}
                        {/*</div>*/}
                    </div>

                    <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d26070.511739230285!2d14.290839902752785!3d46.6203414355388!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4770748fe43b4c4d%3A0x54615428b4239873!2sAnkershofenstra%C3%9Fe+8%2C+9020+Klagenfurt+am+W%C3%B6rthersee%2C+%C3%96sterreich!5e0!3m2!1sde!2sde!4v1518811660923"
                        width="670"
                        height="450"
                        title='Our location'
                    />
                </div>
            </div>
            <Footer />
        </>
    );
};

export default Contact;